/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Icon from "@mdi/react";
import DateRangePicker from "../components/DateRangePicker";
import SearchMultiSelect from "../components/SearchMultiSelect";
import { mdiLoading } from "@mdi/js";
import { useEffect } from "react";

const Filter = ({ fields = [], onChange, loading }) => {
  const [value, setValue] = useState({});
  const [to, setTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const generateGraph = (e) => {
    if (e) e.preventDefault();
    const where = [];
    let data = {};
    fields.map((field) => {
      switch (field.type) {
        case "dateRange":
          data = { ...data, ...(value[field.key] || {}) };
          break;
        case "multiSelect":
          if (field.whereKey)
            where.push({ [field.whereKey]: { [field.operator || "$lk"]: value[field.key].join(",") } });
          else data = { ...data, [field.key]: (value[field.key] || []).join("") };
          break;
      }
    });
    data.where = where.length === 1 ? JSON.stringify(where[0]) : JSON.stringify(where);
    if (onChange) {
      onChange({ ...data, temp: new Date().getTime() });
    }
  };
  useEffect(() => setIsLoading(loading), [loading]);
  useEffect(() => {
    if (to) {
      generateGraph();
    }
  }, [to]);
  useEffect(() => {
    setTimeout(() => {
      setTo(new Date().getTime());
    }, 1000);
  }, []);
  return (
    <div className={"filter-container"}>
      <div className={"filter-content-container"}>
        <button className="btn btn-teal" onClick={generateGraph}>
          {isLoading ? <Icon size={1.2} spin={true} path={mdiLoading} color="#fff" /> : "Generate Chart"}
        </button>
        {fields.map((field, i) => {
          switch (field.type) {
            case "dateRange":
              return (
                <DateRangePicker
                  optional={field.optional}
                  label={field.label}
                  key={field.key}
                  mode={field.mode}
                  defaultEnabled={field.defaultEnabled}
                  onChangeValue={({ startDate, endDate }) => {
                    setValue({ ...value, [field.key]: { startDate, endDate } });
                  }}
                  initialEnd={field.initialEnd}
                  initialStart={field.initialStart}
                  additionalMonths={3}
                />
              );
            case "multiSelect":
              return (
                <SearchMultiSelect
                  key={field.key}
                  label={field.label}
                  options={field.options.filter((o) => o.label && o.label !== "")}
                  rightComponent={field.rightComponent}
                  maxSelect={field.maxSelect}
                  hasPreview={field.hasPreview}
                  forceHasSelectAll={field.forceHasSelectAll}
                  onChange={(data) => {
                    setValue({ ...value, [field.key]: data });
                  }}
                  initialSelected={field.initialSelected}
                />
              );
            case "line":
              return <div className="separator-line" key={`filter-line-${i}`} />;
            default:
              return <div />;
          }
        })}
      </div>
    </div>
  );
};

export default Filter;
